export const updateUser = (snapshot) => ({
  type: "UPDATE_USER",
  payload: snapshot
});
